import React from 'react';
import BuilderSelectMenu from '../../../BuilderSelectMenu';
import { pluralize } from '../../../../../utils/formatText';
import { TimeUnit } from '../../../../../utils/apollo/graphqlSchema';
import { ElementOf } from 'ts-essentials';

interface IProps {
  value: number;
  timeUnit: TimeUnit;
  onChange: (unit: TimeUnit) => void;
  label?: string;
}

const TimeUnitPicker = ({ value, timeUnit, onChange, label }: IProps) => {
  const options = [
    {
      text: pluralize('Day', value),
      value: TimeUnit.Day,
    },
    {
      text: pluralize('Week', value),
      value: TimeUnit.Week,
    },
    {
      text: pluralize('Month', value),
      value: TimeUnit.Month,
    },
    {
      text: pluralize('Quarter', value),
      value: TimeUnit.Quarter,
    },
    {
      text: pluralize('Year', value),
      value: TimeUnit.Year,
    },
  ];

  return (
    <BuilderSelectMenu
      label={label}
      options={options}
      value={timeUnit}
      onChange={(unit) => onChange(unit as ElementOf<typeof options>['value'])}
    />
  );
};

export default TimeUnitPicker;
